import { Link, createFileRoute } from '@tanstack/react-router';
import { ShieldAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import { EmptyState } from '@/components/ui/empty-state';

/** 403 — у роли нет доступа к разделу (цель редиректа requireRole). */
function ForbiddenPage() {
  const { t } = useTranslation();
  return (
    <div className="mx-auto grid min-h-[60vh] max-w-md place-items-center">
      <EmptyState
        icon={ShieldAlert}
        title={t('forbidden.title')}
        description={t('forbidden.description')}
        className="w-full"
        action={
          <Button asChild>
            <Link to="/">{t('forbidden.home')}</Link>
          </Button>
        }
      />
    </div>
  );
}

export const Route = createFileRoute('/_authed/forbidden')({
  component: ForbiddenPage,
});
